import React from 'react';
import { Box, Heading, SimpleGrid, Text, Stack, Link, Flex, Icon } from '@chakra-ui/react';
import { ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
const mentions = [{
  name: 'Magic Patterns',
  description: 'UI component generator. Makes nice-looking components fast.',
  link: 'https://magicpatterns.com/invite/hFqUqMAh5qR2498uDxRf4M'
}, {
  name: 'Granola',
  description: "Cleans up meeting recordings into summaries. Heads up: doesn't work well with Czech.",
  link: 'https://granola.ai/invite/?referee=Martin_Randula'
}, {
  name: 'Suno',
  description: 'Creates songs in any style and language. Generates lyrics, extends existing songs, and turns ideas into full tracks.',
  link: 'https://suno.com/invite/@randula_martin'
}, {
  name: 'v0',
  description: "Vercel's UI generator. Another option for quick prototypes.",
  link: 'https://v0.app/ref/EIPJ3O'
}];
export function HonorableMentions() {
  return <Box id="mentions" as="section" py={10} mt={10} mb={3} bg="gray.50" data-id="element-78">
      <MotionBox initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true
    }} data-id="element-79">
        <Heading as="h2" size="xl" mb={4} textAlign="center" data-id="element-80">
          Other Tools Worth Checking Out
        </Heading>
        <Text textAlign="center" mb={8} color="gray.600" maxW="800px" mx="auto" data-id="element-81">
          I don't use these daily, but they're useful.
        </Text>
        <SimpleGrid columns={{
        base: 1,
        md: 2,
        lg: 4
      }} spacing={6} data-id="element-82">
          {mentions.map((mention, index) => <MotionBox key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} data-id="element-83">
              <Box borderWidth="1px" borderRadius="lg" overflow="hidden" p={6} bg="white" shadow="md" _hover={{
            shadow: 'lg',
            transform: 'translateY(-2px)'
          }} transition="all 0.3s" height="100%" display="flex" flexDirection="column" data-id="element-84">
                <Heading as="h3" size="md" mb={3} data-id="element-85">
                  {mention.name}
                </Heading>
                <Text mb={4} color="gray.600" flex="1" data-id="element-86">
                  {mention.description}
                </Text>
                <Link href={mention.link} isExternal color="#1E73BE" fontWeight="semibold" display="flex" alignItems="center" mt="auto" data-id="element-87">
                  Visit {mention.name}{' '}
                  <ExternalLink size={16} style={{
                marginLeft: '8px'
              }} data-id="element-88" />
                </Link>
              </Box>
            </MotionBox>)}
        </SimpleGrid>
      </MotionBox>
    </Box>;
}